import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import {
  setThefinanceDataActions,
  setThefinanceDataExportActions,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  setTheBankValidationRange , 
  setTheBankValidationTodateRange,
    setTablePositionPersist

} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Select from "react-select";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import useDebouncedEffect from 'use-debounced-effect';


const Bankvalidate = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const UserObjectData = useSelector((state) => state.users.UserData);

      const TablePositionPersist = useSelector(
      (state) => state.PreviousPagePosition.TablePositionPersist
    );
  const [search, setsearch] = useState(
      TablePositionPersist?.Bank_validations?.Params?.search == undefined ||
      TablePositionPersist?.Bank_validations?.Params?.search ==""
        ? ""
        : TablePositionPersist.Bank_validations?.Params.search
    );  
     const [dtpageindex, setdtPageindex] = useState(
        TablePositionPersist?.Bank_validations?.Params?.page == undefined
          ? 1
          : TablePositionPersist.Bank_validations?.Params?.page
      ); 


  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const state = useSelector((state) => state);
  const [multiselect, setMuliselect] = useState([
     { value: "", label: "ALL" }
    // state.ClientBranchIDs.StateName,
  ]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
  ]);  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({  
    //   zone: state.ClientBranchIDs.ZoneName.value,
  //   state: state.ClientBranchIDs.StateName.value,
  //   region: state.ClientBranchIDs.RegionName.value,
  
  zone: "",
  state: "" ,
  region:"" ,
});
const initialStateSearch = {
  stateSearch: "",  };
  const [sno, setsno] = useState(0);

  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


  const [Perecentagedata, setPercentageData] = useState({
    ///---counts  fro the  employees
    aadhar_count: 4,
    bank_count: 2,
    pan_count: 4,
    whats_app_amount: 2,
  });
  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });

        }
    },
    500,
    [SearchDebounance]
);

///-----State----Input Changes
const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.SideBarFiles.BankValidation);
  var gt = convert(state.SideBarFiles.BankValidationTodate);
  // console.log(it, gt);
  const [range, setrange] = useState(
    
    state.SideBarFiles.BankValidation ==""?
  []
  :
  gt < it ?
  [gt, it] :
  [it, gt]
  
  
  // state.SideBarFiles.BankValidation
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

   useEffect(()=>{
    if (range != undefined && range.length > 0 && !range.includes("NaN-aN-aN")) {

     dispatch(setTheBankValidationRange(range[0]))
     dispatch(setTheBankValidationTodateRange(range[1]))

    }
   },[range])
  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    setdtPageindex(1);
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {

        setsearch(e);


      }, 400),
    []
  );

  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
    }
  };


  useEffect(() => {
    if (state.FinanceGetListedData.FinanceDatasCounts) {
      const optionsDatas = {
        aadhar_count:
          state.FinanceGetListedData.FinanceDatasCounts.aadhar_count,
        bank_count: state.FinanceGetListedData.FinanceDatasCounts.bank_count,
        pan_count: state.FinanceGetListedData.FinanceDatasCounts.pan_count,

        whats_app_amount:
          state.FinanceGetListedData.FinanceDatasCounts.whats_app_amount,
      };

      setPercentageData(optionsDatas);
    }
  }, [state.FinanceGetListedData.FinanceDatasCounts]);
  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null && data.state == null && data.zone == null) {
      setData({
        ...data,
        region: "",
      });
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: dtpageindex,
      };
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null && data.region == null && data.state == null) {
      setData({
        ...data,
        zone: "",
      });
    }

    if (selectedVal == null) {
      setMuliselect3({value:"", label:"All"});
      setData({
        ...data,
        zone: "",
      });
    }

  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  useEffect(() => {
    if (range != undefined && range.length > 0 && !range.includes("NaN-aN-aN")) {

    const payload = {
      Params:{

      search: search,
      page_size: 20,
      page: dtpageindex,
      return_type: "normal",
      from_date: range[0],
      to_date: range[1],
      range: true,
      state: data.state,
      region: data.region,
      zone: data.zone,
      export_type: "bank_account",
      },
      export_type:"4"

    };
    dispatch(setThefinanceDataActions(payload));
                      dispatch(
                      setTablePositionPersist({
                        data: payload,
                        pageName: "Bank_validations",
                      })
                    );
    
  }
  }, [dtpageindex, data, range , search]);

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};


  const columns = useMemo(
    () => [
      // {
      //   Header: "TNX ID",
      //   accessor: "",
      //   Cell: (row) => {
      //      if(row.row.original.user_id.id != undefined && row.row.original.user_id.id != null){ 
      //     const userId = row.row.original.user_id.id;
      //     const lastFourDigits = userId.slice(-4);
      //     return <p>{lastFourDigits}</p>; 
      //      }
      //   },
      // },
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => {
          console.log(row.row);
          console.log(sno);
          return <p>{Number(sno + row.row.index + 1)}</p>;
        },
      },
      {
        Header: "EMPLOYEE NAME",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div className="UserName" style={{ cursor: "pointer" }}>
                {row.row.original.user_id != undefined &&
                row.row.original.user_id != null ? (
                  <div className="">
                    <span>{row.row.original.user_id.first_name}</span>
                  </div>
                ) : (
                  <div className="">
                    <span>{"--"}</span>
                  </div>
                )}
              </div>
            </>
          );
        },
      },


      {
        Header: "NAME AS PER BANK",
        accessor: "",
        Cell: (row) => {      
          return (
            <div className="UserName" style={{ position: 'relative' }}>
              {row.row.original.account_holder_name != null &&
              row.row.original.account_holder_name != undefined &&
              row.row.original.account_holder_name !== "" ? (
                <span>{row.row.original.account_holder_name}</span>
              ) : <>{"--"}</>}
            </div>
          );
        },
      },
            {
        Header: "BANK NAME",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              {row.row.original.bank_name != null &&
              row.row.original.bank_name != undefined &&
              row.row.original.bank_name !="" &&
              row.row.original.bank_name != undefined ? (
                <div className="UserName"
                onMouseEnter={() => setShowTooltip(true)} 
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: 'relative' }} // Ensure the tooltip is positioned correctly
              
    >
                  <span
                  
                  >{row.row.original.bank_name ?
                <>{row.row.original.bank_name.slice(0,10)}...</>
                
                :
                <>{row.row.original.bank_name}</>
                
                
                }</span>
                            {showTooltip && (
              <div className="custom-tooltip">
                {row.row.original.bank_name}
              </div>
            )}

                </div>
              ) : (
                <div className="UserName">
                  <span>---</span>
                </div>
              )}
            </>
          );
        },
      },

      {
        Header: "ACCOUNT NUMBER",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              {row.row.original.account_number != null &&
              row.row.original.account_number != undefined &&
              row.row.original.account_number != undefined ? (
                <div className="UserName"
                onMouseEnter={() => setShowTooltip(true)} 
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: 'relative' }}
    
                >
                  <span
                   className="KYcRoles"
                  
                  
                  >
                <>{row.row.original.account_number}</>  
                
                
                
                
                </span>
                {showTooltip && (
              <div className="custom-tooltip">
                {row.row.original.account_number}
              </div>
            )}

                </div>
              ) : (
                <div className="UserName">
                  <span className="KYcRoles">---</span>
                </div>
              )}
            </>
          );
        },
      },

      {
        Header: "IFSC CODE",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.ifsc_code != null &&
              row.row.original.ifsc_code != undefined &&
              row.row.original.ifsc_code != undefined ? (
                <div className="UserName">
                  <span className="KYcRoles">{row.row.original.ifsc_code}</span>
                </div>
              ) : (
                <div className="UserName">
                  <span className="KYcRoles">---</span>
                </div>
              )}
            </>
          );
        },
      },
      {
        Header: "TRANSACTION ID ",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              {row.row.original.bank_transaction_id != null &&
              row.row.original.bank_transaction_id != undefined &&
              row.row.original.bank_transaction_id != "" &&
              row.row.original.bank_transaction_id != undefined ? (
                <div className="UserName"
                onMouseEnter={() => setShowTooltip(true)} 
                onMouseLeave={() => setShowTooltip(false)}
                style={{ position: 'relative' }} 
    >
                  <span                  
                  >{row.row.original.bank_transaction_id.length > 15 ?
                  <>{row.row.original.bank_transaction_id.slice(0, 14)}</>
                :
                <>{row.row.original.bank_transaction_id}</>
                
                }</span>
                            {showTooltip && (
              <div className="custom-tooltip">
                {row.row.original.bank_transaction_id}
              </div>
            )}

                </div>
              ) : (
                <div className="UserName">
                  <span>---</span>
                </div>
              )}
            </>
          );
        },
      },
      {
        Header: "AMOUNT (SANDBOX)",
        accessor: "bank_send_amount",
        Cell: ({ row }) => {
          const amount = row.original.bank_send_amount;

          // Check if the amount is not null or undefined, then format it
          const formattedAmount =
            amount != null && amount != undefined
              ? parseFloat(amount).toFixed(1)
              : "---";

          return (
            <div className="UserName">
              <span>₹{formattedAmount}</span>
            </div>
          );
        },
      },

   
    ],
    [sno]
  );
  // console.log(state.FinanceGetListedData , "8023748state.FinanceGetListedData");
  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '631.344px', 'important');
      rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }

  // console.log(state.pennydropforBank.Bank_Holder_Name  , "73092813908", state.SideBarFiles.BankValidation , state.SideBarFiles.BankValidationTodate);
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Bank Penny Drop Report </h3>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">Bank Penny Drop Report</li>
            </ul> */}
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop:"-27px "
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect}
            />
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              value={multiselect3}
              onremoved={(e) => {
                setMuliselect3(e);
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div className="col-sm-2">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
                            Select Date
                            <span style={{ color: "red" }}>*</span>


            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
                // defaultValue={[
                //   new Date(new Date().setDate(today.getDate() - 30)),
                //   new Date(),
                // ]}
                defaultValue={
    state.SideBarFiles.BankValidation ==""?
    []
:
[new Date(state.SideBarFiles.BankValidation) , new Date(state.SideBarFiles.BankValidationTodate)]

                 }
                 onOpen={() => {
                  openMe()
                }}
             onClose={() => {
                CloseDateRange()
                   }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 300, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000;
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      //   setdtPageindex(1);
                      handlechangedate(localISOTime);
                    });
                  }

                  // if (e != null && e.length === 2) {
                  //   const [startDate, endDate] = e;
                  //   const diffDays = differenceInDays(endDate, startDate);
                  //   if (diffDays === 30) {
                  //     // Since we are using inclusive range, difference should be 30 for 31 days
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else if (diffDays < 30) {
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else {
                  //     toast.error("Please select a range of exactly 31 days.", {
                  //       position: toast.POSITION.TOP_RIGHT,
                  //     });
                  //   }
                  // }
                }}
              />
            </div>
          </div>
        </div>

<br/>
        <div
          style={{
            padding: " 0px 40px",
            marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              position: "relative",
              top: "95px",
              // width: "92%",
              width: "100%",

              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div
              class=" col-12"
              style={{
                position: "relative",
                top: "-16px",
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                zIndex: "1",
                // width: "290px",
              }}
            >
              <div
                align="center"
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  position: "absolute",
                  right: "25px",
                }}
              >
                <a
                  class={`dnbtn ${range != undefined && range.length > 0 && !range.includes("NaN-aN-aN") ?"DISPLAY":"BLOCK"}`}
                  onClick={(e) => {
                    const payload = {
                      return_type: "file",
                      export_type: "bank_account",
                    };
                    dispatch(setThefinanceDataExportActions(payload));
                  }}
                ></a>
              </div>
            </div>
          </div> */}

          <ReactTable
            data={
              range != undefined && range.length > 0 && !range.includes("NaN-aN-aN") ?
              state.FinanceGetListedData.BanckCardData
              :
               []
            
            }
            columns={columns}
            totalItems={state.FinanceGetListedData.Total_Count_bank}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.FinanceGetListedData.Total_Count_bank}
            MakeCreate={false}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            Filter={true}
            NoFilter ={true}
            
                   searchVal={TablePositionPersist?.Bank_validations?.Params?.search == "" || TablePositionPersist?.Bank_validations?.Params?.search ==undefined? "":TablePositionPersist.Bank_validations?.Params.search}
              search_key={true}
          />
        </div>
      </div>



    </>
  );
};

export default Bankvalidate;
